import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { useOnCancelAmends } from 'hooks/use-on-cancel-amends';

import Spinner from '@johnlewispartnership/wtr-ingredients/ingredients/Spinner';

import BrowseHeader from 'components/BrowseHeader/CustomAisleHeader';
import ContentLocation from 'components/ContentLocation';
import NotFound from 'components/NotFound/NotFound';
import ProductRefinements from 'components/Product/Refinements';
import ProductGrid from 'components/ProductGrid';
import MetaHeader from 'components/CustomAisle/MetaHeader';

import { sortByOptions } from 'constants/sortByOptions';

import styles from 'components/CustomAisle/CustomAisle.scss';

const customAisleDefaultPropLocation = {};

const CustomAisle = ({
  aisleRef,
  error = false,
  location = customAisleDefaultPropLocation,
  rootCategory,
  fetchProducts,
}) => {
  const aisleLoading = aisleRef === undefined;
  const notFound = error || aisleRef === null || rootCategory === null;
  const renderContent = !notFound && aisleRef;

  useOnCancelAmends(fetchProducts);

  return (
    <Fragment>
      <MetaHeader />
      {renderContent && (
        <Fragment>
          <BrowseHeader isCustomAisle location={location} />
          <div className={styles.contentBackgroundColour}>
            <ContentLocation name="header" />
          </div>

          <ProductRefinements sortOptions={sortByOptions.browse} />
          <ProductGrid />
        </Fragment>
      )}
      <Spinner
        ariaTextActive="Loading products"
        ariaTextInactive="Products loaded"
        isActive={aisleLoading}
        pageSpinner
      />
      {notFound && <NotFound />}
    </Fragment>
  );
};

CustomAisle.displayName = 'CustomAisle';

CustomAisle.propTypes = {
  fetchProducts: PropTypes.func.isRequired,
  aisleRef: PropTypes.string,
  error: PropTypes.bool,
  location: PropTypes.shape({
    key: PropTypes.string,
  }),
  rootCategory: PropTypes.string,
};

export default CustomAisle;
